import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

export const useResourcesEquipment = ({
  unavailableResources,
}) => {
  const equipment = useSelector((state) => state.schedule.resources.equipment);
  const usedEquipment = useSelector((state) => state.schedule.availability.assignedEquipment)
  const equipmentInitialized = useMemo(() => equipment !== null, [equipment]);
  const [equipmentList, setEquipmentList] = useState(null);

  useEffect(() => {
    if (!equipmentInitialized) return setEquipmentList(null);
    if (!usedEquipment) return setEquipmentList(equipment);

    setEquipmentList(
      structuredClone(equipment).map((eq) => ({
        ...eq,
        isUsed: !!usedEquipment.find((usedEqId) => usedEqId === eq._id),
      }))
    );
  }, [usedEquipment, unavailableResources, equipmentInitialized, equipment]);

  return { equipmentList };
};
